import { useState } from "react";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    image: "https://readdy.ai/api/search-image?query=a%20stylized%20modern%20illustration%20of%20a%20futuristic%20AI%20brain%20analyzing%20stock%20market%20data%20charts%20with%20holographic%20displays%20floating%20candlestick%20patterns%20and%20neural%20network%20connections%20in%20warm%20tech%20style%20soft%20gradient%20background%20minimalist%20flat%20vector%20art%20with%20clean%20lines%20and%20geometric%20shapes&width=800&height=1000&seq=onboard-slide-1&orientation=portrait",
    title: "不懂股票？",
    subtitle: "看 AI 怎么分析",
    description: "4个 AI 视角自动扫描全市场，基本面、技术面、情绪面、新闻面，一站式呈现在你面前",
  },
  {
    image: "https://readdy.ai/api/search-image?query=a%20stylish%20digital%20illustration%20of%20four%20different%20AI%20analysis%20perspectives%20displayed%20on%20floating%20holographic%20screens%20showing%20financial%20data%20technical%20charts%20sentiment%20indicators%20and%20news%20analysis%20all%20surrounding%20a%20central%20stock%20market%20display%20with%20warm%20modern%20tech%20aesthetic%20and%20soft%20gradients&width=800&height=1000&seq=onboard-slide-2&orientation=portrait",
    title: "4 个 AI 视角",
    subtitle: "全市场扫描",
    description: "每只股票从基本面估值、技术形态、资金情绪、新闻影响四个维度深度分析",
  },
  {
    image: "https://readdy.ai/api/search-image?query=a%20reassuring%20illustration%20of%20a%20shield%20with%20AI%20circuit%20patterns%20protecting%20a%20simulated%20trading%20environment%20with%20a%20lock%20icon%20and%20the%20word%20simulation%20in%20clean%20typography%20soft%20friendly%20color%20palette%20with%20warm%20light%20background%20trustworthy%20and%20safe%20feeling%20flat%20vector%20art%20style&width=800&height=1000&seq=onboard-slide-3&orientation=portrait",
    title: "全程模拟",
    subtitle: "不碰真钱，放心学",
    description: "虚拟资金操作，零风险体验 AI 投资决策全过程，学懂再考虑实战",
  },
];

export default function Onboarding() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    if (current < slides.length - 1) {
      setCurrent(current + 1);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      {/* Slide Area */}
      <div className="flex-1 relative overflow-hidden">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`absolute inset-0 transition-all duration-500 flex flex-col ${
              i === current ? "opacity-100 translate-x-0" : i < current ? "opacity-0 -translate-x-full" : "opacity-0 translate-x-full"
            }`}
          >
            <div className="flex-1 flex items-center justify-center px-4">
              <div className="w-full max-w-[340px] aspect-[4/5] rounded-3xl overflow-hidden">
                <img src={slide.image} alt={slide.title} className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <div className="px-8 pb-8 text-center">
              <h2 className="text-2xl font-bold text-foreground-950 mb-1">{slide.title}</h2>
              <p className="text-lg font-semibold text-primary-500 mb-3">{slide.subtitle}</p>
              <p className="text-sm text-foreground-500 leading-relaxed">{slide.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Controls */}
      <div className="px-8 pb-10">
        {/* Dots */}
        <div className="flex justify-center gap-2 mb-6">
          {slides.map((_, i) => (
            <div
              key={i}
              className={`rounded-full transition-all ${i === current ? "w-6 h-2 bg-primary-500" : "w-2 h-2 bg-background-300"}`}
            />
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/login")}
            className="text-sm text-foreground-400 cursor-pointer whitespace-nowrap"
          >
            跳过
          </button>
          <button
            onClick={handleNext}
            className="flex-1 py-3.5 bg-gradient-to-r from-primary-500 to-accent-500 text-white rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap"
          >
            {current === slides.length - 1 ? "已有账号，去登录" : "下一步"}
          </button>
        </div>

        {current === slides.length - 1 && (
          <p className="text-[10px] text-foreground-400 text-center mt-3">
            本产品为学习模拟工具，不构成投资建议
          </p>
        )}
      </div>
    </div>
  );
}
